import { Button, HelperText, Label, Modal, ModalBody, ModalFooter, ModalHeader } from '@/_components';
import { DownloadButton } from '@/_containers/buttons';

import { Preview } from './components';
import type { UseImageInputReturn } from './use-media-input';

export function ImagePreviewModal({
  handleImageSelector,
  onUpload,
  onCancel,
  onHandleOpen,
  onDelete,
  handleCloseOnly,
  modelOpen: [isOpen],
  fileIssue,
  file,
  isPending,
  isDeleting,
  singleValue,
  mode,
  imageUrl,
  isRemovable,
  isUploadable,
  isDownloadable,
  filePreviewUrl,
  label,
  disabled,
  shape,
  size,
  addPadding,
  type,
}: UseImageInputReturn) {
  let dimensions = size === 'lg' ? 'size-48 md:size-56' : 'size-48';
  if (shape === 'rectangle') {
    // TODO: fix this rectangle size
    dimensions = size === 'lg' ? 'h-48 w-[16.09rem] md:h-56 md:w-[18.73rem]' : 'h-48 w-[16.09rem]';
  }

  const previewDisabled = disabled || mode === 'DELETE';

  return (
    <Modal open={isOpen} onClose={onCancel} disableInternalClosing={isPending}>
      {mode === 'UPDATE' && <ModalHeader>{isUploadable ? `Upload ${label}` : label}</ModalHeader>}
      {mode === 'CREATE' && <ModalHeader>Select</ModalHeader>}
      {mode === 'DELETE' && <ModalHeader>Preview</ModalHeader>}

      <ModalBody className="flex flex-col items-center justify-center gap-y-4 pt-8 pb-12">
        <Preview
          src={filePreviewUrl}
          disabled={previewDisabled}
          shape={shape}
          dimensions={dimensions}
          hideIcon={!(previewDisabled && Boolean(imageUrl))}
          callback={handleImageSelector}
          addPadding={addPadding}
          type={type}
          isModal
        >
          {Boolean(fileIssue) && (
            <HelperText className="text-error w-64">
              <span dangerouslySetInnerHTML={{ __html: fileIssue ?? '' }} />
            </HelperText>
          )}
          <Label>{file ? file?.name : (singleValue?.name ?? '')}</Label>
        </Preview>
      </ModalBody>

      {mode === 'UPDATE' && (
        <ModalFooter>
          {/* <Button
            modal
            as={isRemovable || isDownloadable ? 'contained' : 'outline'}
            onClick={onCancel}
            disabled={isPending}
          >
            {isUploadable ? 'Cancel' : 'Close'}
          </Button> */}
          {isDownloadable && (
            <>
              <DownloadButton fileSrc={singleValue?.url || ''} fileName={singleValue?.name ?? ''}>
                Download
              </DownloadButton>
              <Button modal as="outline" onClick={onHandleOpen}>
                Open
              </Button>
            </>
          )}

          {isUploadable && (
            <Button modal onClick={onUpload} showLoader={isPending} disabled={Boolean(fileIssue)}>
              Upload
            </Button>
          )}
          {isRemovable && (
            <Button modal onClick={onDelete} theme="error" as="outline" showLoader={isDeleting}>
              Remove
            </Button>
          )}
        </ModalFooter>
      )}

      {mode === 'CREATE' && (
        <ModalFooter>
          <Button modal onClick={onCancel} theme="error" as="outline" showLoader={isDeleting}>
            Remove & Close
          </Button>
          <Button modal as="contained" onClick={handleCloseOnly} disabled={isPending || Boolean(fileIssue)}>
            Select
          </Button>
        </ModalFooter>
      )}

      {mode === 'DELETE' && (
        <ModalFooter>
          <Button modal as={isRemovable ? 'contained' : 'outline'} onClick={onCancel} disabled={isPending}>
            Close
          </Button>
          {isRemovable && (
            <Button modal onClick={onDelete} theme="error" as="outline" showLoader={isDeleting}>
              Remove
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
}
